var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShareKakao(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#FEE500"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 12.5C14.4386 12.5 11.75 15.8625 11.75 18.7073C11.75 20.8389 13.1782 22.7191 15.3534 23.8364L14.4386 27.0923C14.357 27.381 14.6953 27.6101 14.9547 27.444L18.9669 24.8639C19.3052 24.8959 19.6498 24.9146 20 24.9146C24.5558 24.9146 28.25 22.1356 28.25 18.7073C28.25 15.8625 25.25 12.5 20 12.5Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareKakao);
export default __webpack_public_path__ + "static/media/share-kakao.53e4db16068ccee9c22474f97f3bea5d.svg";
export { ForwardRef as ReactComponent };